export enum BrandId {
  Petlog = 'petlog',
  Identibase = 'identibase',
  Default = 'default'
}
